import Vue from "vue";
import VueAxios from "vue-axios";
import api from "../modules/shared/helpers/api";

Vue.use(VueAxios, api);
